/** Date / display helpers for examination portal */

export const formatDate = (d) => {
  if (!d) return "";
  return new Date(d).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatDateInput = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toISOString().slice(0, 10);
};

export const toId = (v) => {
  if (!v) return "";
  if (typeof v === "string") return v;
  return v._id || v.id || "";
};

export const pickList = (res, keys = ["data", "exams", "schedules", "rooms", "seatingPlans", "templates", "students"]) => {
  if (Array.isArray(res)) return res;
  if (!res || typeof res !== "object") return [];
  for (const k of keys) {
    if (Array.isArray(res[k])) return res[k];
  }
  return [];
};

export const chapterOptionsFromTemplate = (template) => {
  if (!template?.chapters?.length) return [];
  return template.chapters.map((c) => ({
    value: c.chapterNo,
    label: `${c.chapterNo}. ${c.chapterName || "Chapter"}`,
  }));
};
